BatchGeoStore.addReducer(
  "MarkerMeasure",
  {
    enabled: false,
    renderMarker: true,
    polylineLimit: 500,
    isDragging: false,
    dragOriginPoint: {
      x: null,
      y: null,
    },
    position: new google.maps.LatLng({
      lat: 0,
      lng: 0,
    }),
  },
  {
    MARKER_MEASURE_ENABLE: function (state, action) {
      return $.extend(true, {}, state, {
        enabled: true,
        polylineLimit: action.polylineLimit,
      });
    },
    MARKER_MEASURE_DISABLE: function () {
      return {
        enabled: false,
        renderMarker: true,
        position: new google.maps.LatLng({
          lat: 0,
          lng: 0,
        }),
      };
    },
    MARKER_MEASURE_RENDER_MARKER: function (state, action) {
      return Object.assign({}, state, {
        renderMarker: action.renderMarker,
      });
    },
    MARKER_MEASURE_SET_POSITION: function (state, action) {
      var newState = Object.assign({}, state);
      newState.position = new google.maps.LatLng({
        lat: action.position.lat,
        lng: action.position.lng,
      });
      return newState;
    },
    MARKER_MEASURE_DRAG_START: function (state, action) {
      return Object.assign({}, state, {
        isDragging: true,
        dragOriginPoint: {
          x: action.x,
          y: action.y,
        },
      });
    },
    MARKER_MEASURE_DRAG: function (state, action) {
      return Object.assign({}, state, {
        position: action.position,
        dragOriginPoint: {
          x: action.x,
          y: action.y,
        },
      });
    },
    MARKER_MEASURE_DRAG_STOP: function (state, action) {
      return Object.assign({}, state, {
        isDragging: false,
        dragOriginPoint: {
          x: action.x,
          y: action.y,
        },
      });
    },
  },
);
